export default __webpack_public_path__ + "static/media/teacher_schedule_desktop.8144f3a1.jpg";